export default __webpack_public_path__ + "static/media/Selma_Prodanovic_AHV_In_Moms_We_Trust.ee4b2eb1.jpg";